import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LANDING_PAGES } from '../data/seoLandingPages';
import { openCookieSettings } from '../utils/cookieConsent';

const SiteFooter = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <div className="text-2xl font-bold text-white mb-4">Swapify</div>
            <p className="text-sm">Voor cadeaubonnen die je echt gebruikt, voor minder geld.</p>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Ontdekken</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/cadeaubonnen-kopen" className="hover:text-white transition">Cadeaubonnen kopen</Link></li>
              <li><Link to="/cadeaubonnen-verkopen" className="hover:text-white transition">Cadeaubonnen verkopen</Link></li>
              <li><Link to="/marketplace" className="hover:text-white transition">Marktplaats</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Populaire merken</h4>
            <ul className="space-y-2 text-sm">
              {BRAND_LANDING_PAGES.map((page) => (
                <li key={page.slug}>
                  <Link to={page.path} className="hover:text-white transition">{page.displayBrand || page.brand}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4">Juridisch</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-white transition">Algemene voorwaarden</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition">Privacy & Cookies</Link></li>
              <li>
                <button
                  onClick={openCookieSettings}
                  className="transition hover:text-white"
                  type="button"
                >
                  Cookie-instellingen
                </button>
              </li>
              <li><a href="mailto:hello@swapify.nl" className="hover:text-white transition">hello@swapify.nl</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Swapify. Alle rechten voorbehouden.</p>
          <p className="mt-2 text-gray-500">Swapify | KVK: 71562214 | Bert Haanstrakade 96 1087 DN Amsterdam | hello@swapify.nl</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
